module.exports = __webpack_public_path__ + "img/ldyTitle1.85a41057.png";